import React from 'react';
import { FileSpreadsheet, X, Download, Filter, AlertTriangle } from 'lucide-react';

/**
 * Modal pilihan cakupan export Excel.
 * Dipakai halaman master Sparepart (spareparts & inventori/spareparts).
 *
 * Props:
 *  - open / onClose
 *  - onExportAll / onExportFiltered  (dipanggil saat opsi diklik)
 *  - allCount / filteredCount        (jumlah baris tiap opsi)
 *  - filterSummary                   (array teks filter aktif, mis. ['Pencarian: "rem"'])
 *  - title, busy
 */
export default function ExportExcelModal({
  open,
  onClose,
  onExportAll,
  onExportFiltered,
  allCount = 0,
  filteredCount = 0,
  filterSummary = [],
  title = 'Export Excel',
  busy = false,
}) {
  if (!open) return null;

  const filterAktif = filterSummary.filter(Boolean);
  const adaFilter = filterAktif.length > 0;
  const semuaKosong = allCount === 0;

  const optStyle = { width: '100%', justifyContent: 'center', marginBottom: 4 };
  const hintStyle = { fontSize: '0.72rem', color: 'var(--gray-400)', marginBottom: 14, lineHeight: 1.45 };

  return (
    <div className="modal-overlay" onClick={() => { if (!busy) onClose(); }}>
      <div className="modal-content" style={{ maxWidth: 470 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <FileSpreadsheet size={18} style={{ marginRight: 8 }} />
            {title}
          </h3>
          <button className="btn-icon" onClick={onClose} disabled={busy} aria-label="Tutup">
            <X size={18} />
          </button>
        </div>

        <div className="modal-body">
          <p style={{ fontSize: '0.85rem', color: 'var(--gray-500)', marginTop: 0, marginBottom: 14 }}>
            Pilih cakupan data yang akan diunduh sebagai file Excel (.xlsx):
          </p>

          <button
            type="button"
            className="btn btn-primary"
            style={optStyle}
            onClick={onExportAll}
            disabled={busy || semuaKosong}
            data-export-opt="all"
          >
            <Download size={16} />
            <span>Export Semua Data ({allCount} item)</span>
          </button>
          <div style={hintStyle}>
            Seluruh data master, <strong>tidak mengikuti</strong> pencarian/filter yang sedang aktif.
          </div>

          <button
            type="button"
            className="btn btn-secondary"
            style={optStyle}
            onClick={onExportFiltered}
            disabled={busy || !adaFilter || filteredCount === 0}
            data-export-opt="filtered"
          >
            <Filter size={16} />
            <span>Export Hasil Filter ({filteredCount} item)</span>
          </button>
          <div style={hintStyle}>
            {adaFilter ? (
              <>Hanya baris yang tampil sekarang — {filterAktif.join(' · ')}.</>
            ) : (
              <span style={{ display: 'inline-flex', alignItems: 'flex-start', gap: 4 }}>
                <AlertTriangle size={12} style={{ marginTop: 2, flexShrink: 0 }} />
                Belum ada filter aktif — pilih ini setelah mengisi pencarian/kategori/gudang.
              </span>
            )}
          </div>

          {busy && (
            <div style={{ fontSize: '0.78rem', color: 'var(--info)', textAlign: 'center' }}>
              Menyiapkan file Excel...
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={busy}>Batal</button>
        </div>
      </div>
    </div>
  );
}
